import { render, staticRenderFns } from "./DepartmentEmployeesWidget.vue?vue&type=template&id=5b771e84&"
import script from "./DepartmentEmployeesWidget.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEmployeesWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports